import React from 'react';
import { Link, Redirect } from "react-router-dom";
import {
	Card,
	Form,
	Input,
	Button,
	Select,
	message,
	Alert,
	Spin,
	Divider,
	Typography,
	Row,
	Col,
} from 'antd';
import {
	DiffOutlined,
	SaveOutlined,
	CloseCircleOutlined,
	AppstoreOutlined,
	CarOutlined,
	TagOutlined,
	TagsOutlined,
	ClusterOutlined,
	SyncOutlined,
	ArrowLeftOutlined,
	EditOutlined,
	PlusCircleOutlined,
} from '@ant-design/icons';
import moment from 'moment';

import Config from '../../Config';

import { connect } from 'react-redux';
import {
	initHandler,
	ajaxViewHandler,
	ajaxHandler,
	setConfig,
	extractResult,
} from "../../store/actions";
import { Helmet } from "react-helmet";
import ErrorAlertModal from '../../components/ErrorAlertModal';

const { Text } = Typography;

const configClass = {
	apiUrl: {
		preview: "master/api/tipe/",
		merek: "master/api/merek/",
		jenis: 'master/api/jenis/kendaraan/',
		golongan: 'master/api/golongan/',
		akun: 'master/api/akun/',
	},
	pageUrl: { data: '/admin/tipe/' },
};

const config = new Config();

const FIELD_STYLE = { borderRadius: 8, height: 38 };

const SectionHeader = ({ icon, title }) => (
	<div style={{
		padding: '12px 24px',
		background: 'linear-gradient(135deg, #0f284711, #1e4d8a11)',
		borderBottom: '1.5px solid #d0dff5',
		borderTop: '1px solid #f0f0f0',
		display: 'flex', alignItems: 'center', gap: 10,
	}}>
		<span style={{ color: '#1e4d8a', fontSize: 15 }}>{icon}</span>
		<Text strong style={{ fontSize: 14, color: '#0f2847' }}>{title}</Text>
	</div>
);

class FormTipe extends React.Component {
	formRef = React.createRef();

	constructor(props) {
		super(props);
		this.state = {
			errComponent: false,
			errTitle: '',
			errMsg: '',
			loadingButton: false,

			loadingMerek: false,
			listMerek: null,

			loadingJenis: false,
			listJenis: null,

			loadingGolongan: false,
			listGolongan: null,

			isKodeGenerated: false,
			kodeMerek: null,
			kodeJenis: null,
			loadingGenerate: false,
			namaTersedia: null,

			aksi: 'tambah',
			method: 'post',
			idLama: '',
			isRedirect: false,

			isMobile: window.innerWidth <= 768,
		};
	}

	UNSAFE_componentWillMount() {
		this.props.initHandler();
	}

	componentDidMount() {
		this.loadJenisList();
		this.loadGolonganList();
		this._handleResize = () => this.setState({ isMobile: window.innerWidth <= 768 });
		window.addEventListener('resize', this._handleResize);
	}

	componentWillUnmount() {
		window.removeEventListener('resize', this._handleResize);
		clearTimeout(this._namaCheckTimer);
	}

	loadJenisList() {
		const rule = {
			destination: {
				stateProgressName: 'loadingJenis',
				endPoint: configClass.apiUrl.jenis,
				stateDestination: 'listJenis',
			},
			nextDestination: null,
		};
		this.getMasterList(rule, true);
	}

	loadGolonganList() {
		const rule = {
			destination: {
				stateProgressName: 'loadingGolongan',
				endPoint: configClass.apiUrl.golongan + '?limit=200',
				stateDestination: 'listGolongan',
			},
			nextDestination: null,
		};
		this.getMasterList(rule);
	}

	async loadMerekByJenis(jenisId, ensureMerekId = null, ensureMerekNama = null) {
		if (!jenisId) return;
		this.setState({ listMerek: null, loadingMerek: true });
		await this.props.ajaxViewHandler('get', `${configClass.apiUrl.merek}?jenis=${jenisId}`)
			.then((action) => {
				const { isSuccess, responseMsg } = extractResult(action);
				if (isSuccess) {
					let listData = responseMsg;
					if (ensureMerekId) {
						const results = listData.results || (Array.isArray(listData) ? listData : []);
						const found = results.some(r => r.id === ensureMerekId);
						if (!found) {
							const item = { id: ensureMerekId, kode: '', nama: ensureMerekNama || String(ensureMerekId) };
							if (listData.results !== undefined) {
								listData = { ...listData, results: [item, ...listData.results] };
							} else {
								listData = [item, ...(Array.isArray(listData) ? listData : [])];
							}
						}
					}
					this.setState({ listMerek: listData });
				}
				this.setState({ loadingMerek: false });
			})
			.catch(() => {
				this.setState({ loadingMerek: false });
			});
	}

	async preview(id) {
		message.loading({ content: 'Memuat data...', duration: 0, key: 'toast' });
		this.props.ajaxViewHandler('get', configClass.apiUrl.preview + id)
			.then((action) => {
				const { isSuccess, responseMsg: data } = extractResult(action);
				if (isSuccess) {
					this.formRef.current.setFieldsValue(data);
					for (var key in data) {
						const dateRegex = /^[0-9]{2}\-[0-9]{2}\-[0-9]{4}$/;
						const dateTimeRegex = /^[0-9]{2}\-[0-9]{2}\-[0-9]{4} [0-9]{2}\:[0-9]{2}\:[0-9]{2}$/;
						if (dateRegex.test(data[key])) {
							this.formRef.current.setFieldsValue({ [key + '_picker']: moment(data[key], 'DD-MM-YYYY') });
						} else if (dateTimeRegex.test(data[key])) {
							this.formRef.current.setFieldsValue({ [key + '_picker']: moment(data[key], 'DD-MM-YYYY HH:mm:ss') });
						}
					}
					message.destroy();
					if (data.jenis) {
						this.setState({ kodeJenis: data.jenis, kodeMerek: data.merek });
						// Ensure jenis option tersedia di list (meski tidak di halaman pertama)
						const listJenis = this.state.listJenis;
						if (listJenis) {
							const results = listJenis.results || (Array.isArray(listJenis) ? listJenis : []);
							if (!results.some(r => r.id === data.jenis)) {
								const jenisItem = { id: data.jenis, kode: '', nama: data.jenis_nama || String(data.jenis) };
								if (listJenis.results !== undefined) {
									this.setState(prev => ({
										listJenis: { ...prev.listJenis, results: [jenisItem, ...prev.listJenis.results] }
									}));
								} else if (Array.isArray(listJenis)) {
									this.setState(prev => ({ listJenis: [jenisItem, ...prev.listJenis] }));
								}
							}
						}
						// Load merek, pastikan merek aktif tersedia meski pagination
						this.loadMerekByJenis(data.jenis, data.merek, data.merek_nama);
					}
					this.setState({ aksi: 'edit', method: 'put', idLama: id + '/' });
				} else {
					const errTitle = 'Gagal memuat data';
					this.setState({ errTitle, errMsg: data });
					message.error({ content: errTitle, duration: 2, key: 'toast' });
				}
			})
			.catch(() => {
				message.error({ content: 'Gagal request data, coba lagi', duration: 2, key: 'toast' });
			});
	}

	handleSubmit = (values) => {
		this.postData(values);
	}

	async postData(datas) {
		message.loading({ content: 'Menyimpan...', key: 'toast' });
		this.setState({ errTitle: '', errMsg: '' });
		this.props.ajaxHandler(this.state.method, configClass.apiUrl.preview + this.state.idLama, datas, false, true)
			.then((action) => {
				this.setState({ loadingButton: false });
				const { isSuccess, responseMsg } = extractResult(action);
				if (isSuccess) {
					message.success({ content: 'Data berhasil disimpan', duration: 2, key: 'toast' });
					this.setState({ isRedirect: true });
				} else {
					const errTitle = 'Gagal menyimpan data';
					message.error({ content: errTitle, duration: 2, key: 'toast' });
					this.setState({ errTitle, errMsg: responseMsg });
				}
			})
			.catch(() => {
				this.setState({ loadingButton: false });
				message.error({ content: 'Kesalahan pengiriman data, coba lagi', duration: 2, key: 'toast' });
			});
	}

	async getMasterList(rule, isFinal = false) {
		const destination = rule.destination;
		const nextDestination = rule.nextDestination;
		this.setState({ [destination.stateProgressName]: true });
		this.props.ajaxViewHandler("get", destination.endPoint)
			.then((action) => {
				const { isSuccess, responseMsg: data } = extractResult(action);
				if (isSuccess) {
					if (data.count != undefined) {
						let newState;
						if (this.state[destination.stateDestination] == null) {
							newState = data;
						} else if (destination.stateProgressName.includes("_searching")) {
							newState = data;
						} else {
							const old = this.state[destination.stateDestination];
							newState = { count: data.count, next: data.next, previous: data.previous, results: [...old.results, ...data.results] };
						}
						this.setState({ [destination.stateDestination]: newState });
					} else if (data.results != undefined) {
						this.setState({ [destination.stateDestination]: data.results });
					} else {
						this.setState({ [destination.stateDestination]: Array.isArray(data) ? data : [data] });
					}
					if (isFinal && this.props.match.params.id != undefined) {
						this.preview(this.props.match.params.id);
					}
				} else {
					this.setState({ errComponent: true });
				}
				this.setState({ [destination.stateProgressName]: false });
			})
			.catch(() => {
				message.error({ content: "Gagal request data, coba lagi", duration: 2, key: "toast" });
				this.setState({ errTitle: "Gagal request data master", errMsg: '' });
				this.setState({ [destination.stateProgressName]: false });
			});
		if (nextDestination != null) {
			this.getMasterList({
				destination: {
					stateProgressName: nextDestination.stateProgressName,
					endPoint: nextDestination.endPoint,
					stateDestination: nextDestination.stateDestination,
				},
				nextDestination: nextDestination.next,
			});
		}
	}

	generateSelect(stateName, baseUrl, key, value, extra = {}) {
		const { disabled = false, onChangeOverride = null } = extra;
		const addQuery = (url, qs) => url + (url.includes('?') ? '&' : '?') + qs;

		return this.state["loading" + stateName] ? (
			<div style={{ padding: '8px 0' }}><Spin size="small" /> <Text type="secondary" style={{ fontSize: 12 }}>Memuat...</Text></div>
		) : (
			<Select
				showSearch
				placeholder={disabled ? 'Pilih jenis kendaraan dulu' : 'Pilih...'}
				optionFilterProp="children"
				disabled={disabled}
				style={{ borderRadius: 8 }}
				onSearch={(val) => {
					this.getMasterList({
						destination: {
							stateProgressName: "loading" + stateName + "_searching",
							endPoint: addQuery(baseUrl, "search=" + encodeURIComponent(val)),
							stateDestination: "list" + stateName,
						},
						nextDestination: null,
					});
				}}
				onPopupScroll={(e) => {
					e.persist();
					const target = e.target;
					if (target.scrollTop + target.offsetHeight >= target.scrollHeight) {
						const listState = this.state["list" + stateName];
						if (listState && listState.next) {
							this.getMasterList({
								destination: {
									stateProgressName: "loading" + stateName + "Paging",
									endPoint: listState.next,
									stateDestination: "list" + stateName,
								},
								nextDestination: null,
							});
						}
					}
				}}
				onChange={(val) => {
					if (onChangeOverride) return onChangeOverride(val);
					if (stateName === "Jenis") this.setState({ kodeJenis: val });
					else if (stateName === "Merek") this.setState({ kodeMerek: val });
				}}
			>
				{this.state["loading" + stateName + "_searching"] && (
					<Select.Option value=""><Spin size="small" /></Select.Option>
				)}
				{(this.state["list" + stateName] && (this.state["list" + stateName].results || this.state["list" + stateName]) || []).map((item) => (
					<Select.Option key={item[key]} value={item[key]}>
						{item.kode ? item.kode + " - " + item[value] : item[value]}
					</Select.Option>
				))}
				{this.state["list" + stateName] && this.state["list" + stateName].next && (
					<Select.Option value=""><Spin size="small" /></Select.Option>
				)}
			</Select>
		);
	}

	// Debounce: cek ke backend baru dijalankan ~500ms setelah user berhenti mengetik,
	// supaya tidak request ke check-nama di tiap huruf yang diketik
	validateNamaTidakDuplikat = (_, value) => {
		clearTimeout(this._namaCheckTimer);

		if (!value) {
			this.setState({ namaTersedia: null });
			return Promise.resolve();
		}

		return new Promise((resolve, reject) => {
			this._namaCheckTimer = setTimeout(async () => {
				const isEdit = this.state.aksi === 'edit';
				let url = `master/api/tipe/check-nama/?nama=${encodeURIComponent(value)}`;
				if (isEdit && this.state.idLama) {
					const id = this.state.idLama.replace('/', '');
					url += `&exclude_id=${id}`;
				}
				const action = await this.props.ajaxViewHandler('get', url);
				const { isSuccess, responseMsg } = extractResult(action);
				if (isSuccess && responseMsg && responseMsg.exists) {
					this.setState({ namaTersedia: false });
					reject(new Error(`Nama tipe "${responseMsg.nama_norm}" sudah terdaftar di database`));
				} else {
					this.setState({ namaTersedia: true });
					resolve();
				}
			}, 500);
		});
	};

	handleNamaChange = () => {
		this.setState({ namaTersedia: null, isKodeGenerated: false });
		this.formRef.current.setFieldsValue({ kode: undefined });
	};

	handleJenisChange = (jenisId) => {
		this.setState({
			kodeJenis: jenisId,
			kodeMerek: null,
			listMerek: null,
			isKodeGenerated: false,
		});
		this.formRef.current.setFieldsValue({ merek: undefined, kode: undefined, golongan: undefined });
		this.loadMerekByJenis(jenisId);
	};

	handleMerekChange = (merekId) => {
		this.setState({ kodeMerek: merekId, isKodeGenerated: false });
		this.formRef.current.setFieldsValue({ kode: undefined, golongan: undefined });
	};

	generateKode() {
		const params = new FormData();
		params.append("merek", this.state.kodeMerek);
		params.append("jenis", this.state.kodeJenis);

		this.setState({ loadingGenerate: true, errTitle: '', errMsg: '' });
		this.props.ajaxHandler("post", configClass.apiUrl.akun, params, true, true)
			.then((action) => {
				this.setState({ loadingGenerate: false });
				const { isSuccess, responseMsg } = extractResult(action);
				if (isSuccess) {
					this.formRef.current.setFieldsValue({ kode: responseMsg.akun });
					this.setState({ isKodeGenerated: true });
				} else {
					const errTitle = 'Gagal generate kode';
					message.error({ content: errTitle, duration: 2, key: 'toast' });
					this.setState({ isKodeGenerated: false, errTitle, errMsg: responseMsg });
				}
			})
			.catch(() => {
				this.setState({ loadingGenerate: false });
				message.error({ content: 'Kesalahan pengiriman data, coba lagi', duration: 2, key: 'toast' });
			});
	}

	render() {
		if (this.state.isRedirect) {
			return <Redirect to={configClass.pageUrl.data} />;
		}

		const { isMobile, aksi, errMsg, errTitle, loadingButton, errComponent, listJenis, listMerek, listGolongan, loadingGolongan, kodeMerek, kodeJenis, loadingGenerate, isKodeGenerated, namaTersedia } = this.state;
		const isEdit = aksi === 'edit';
		const pageTitle = isEdit ? 'Edit Tipe' : 'Tambah Tipe';
		const canGenerate = !isEdit && kodeJenis != null && kodeMerek != null && namaTersedia === true && !loadingGenerate;
		const canSubmit = isEdit || isKodeGenerated;

		return (
			<div>
				<Helmet>
					<title>{pageTitle + ' | ' + config.get_site_info().name}</title>
					<style>{`
						.form-tipe-wrap .ant-form-item-label > label {
							font-weight: 600; color: #374151; font-size: 13px;
						}
						.form-tipe-wrap .ant-input:focus,
						.form-tipe-wrap .ant-select-focused .ant-select-selector {
							border-color: #1e4d8a !important;
							box-shadow: 0 0 0 2px rgba(30,77,138,0.1) !important;
						}
					`}</style>
				</Helmet>


				<ErrorAlertModal
					visible={errMsg !== ''}
					title={errTitle}
					error={errMsg}
					onClose={() => this.setState({ errTitle: '', errMsg: '' })}
				/>

				<Form
					layout="vertical"
					name="fdata"
					onFinish={this.handleSubmit}
					ref={this.formRef}
					className="form-tipe-wrap"
				>
					<Card
						style={{ borderRadius: 14, boxShadow: '0 4px 20px rgba(0,0,0,0.07)', overflow: 'hidden' }}
						bodyStyle={{ padding: 0 }}
					>
						{/* ── Header ── */}
						<div style={{
							background: 'linear-gradient(135deg, #0f2847, #1e4d8a)',
							padding: '20px 24px',
							display: 'flex', alignItems: 'center', gap: 16,
						}}>
							<div style={{
								width: 52, height: 52, borderRadius: 14,
								background: 'rgba(255,255,255,0.15)',
								display: 'flex', alignItems: 'center', justifyContent: 'center', flexShrink: 0,
							}}>
								{isEdit
									? <EditOutlined style={{ color: '#fff', fontSize: 24 }} />
									: <PlusCircleOutlined style={{ color: '#fff', fontSize: 24 }} />
								}
							</div>
							<div style={{ flex: 1, minWidth: 0 }}>
								<div style={{ color: '#fff', fontWeight: 700, fontSize: 18, lineHeight: 1.3 }}>
									{pageTitle}
								</div>
								<div style={{ color: 'rgba(255,255,255,0.65)', fontSize: 13, marginTop: 3 }}>
									{isEdit ? 'Ubah informasi tipe kendaraan' : 'Isi formulir untuk menambah tipe baru'}
								</div>
							</div>
							<Link to={configClass.pageUrl.data}>
								<Button
									icon={<ArrowLeftOutlined />}
									style={{ background: 'rgba(255,255,255,0.15)', border: 'none', color: '#fff', borderRadius: 8 }}
								>
									{!isMobile && 'Kembali'}
								</Button>
							</Link>
						</div>

						{/* ── Section: Data Tipe ── */}
						<SectionHeader icon={<AppstoreOutlined />} title="Data Tipe Kendaraan" />
						<div style={{ padding: '20px 24px' }}>

							{/* Jenis Kendaraan */}
							<Form.Item
								label={<span><ClusterOutlined style={{ color: '#1e4d8a', marginRight: 6 }} />Jenis Kendaraan</span>}
								name="jenis"
								rules={[{ required: true, message: 'Jenis kendaraan harus dipilih' }]}
							>
								{listJenis != null
									? this.generateSelect("Jenis", configClass.apiUrl.jenis, "id", "nama", {
										onChangeOverride: this.handleJenisChange,
									})
									: <Select placeholder="Memuat..." disabled style={{ borderRadius: 8 }} />
								}
							</Form.Item>

							{/* Merek — aktif setelah Jenis dipilih */}
							<Form.Item
								label={
									<span>
										<CarOutlined style={{ color: '#1e4d8a', marginRight: 6 }} />
										Merek
										{listMerek == null && kodeJenis == null && (
											<Text type="secondary" style={{ fontSize: 11, marginLeft: 8 }}>
												(pilih jenis kendaraan dulu)
											</Text>
										)}
									</span>
								}
								name="merek"
								rules={[{ required: true, message: 'Merek harus dipilih' }]}
							>
								{listMerek != null
									? this.generateSelect("Merek", configClass.apiUrl.merek, "id", "nama", {
										onChangeOverride: this.handleMerekChange,
									})
									: <Select placeholder={kodeJenis ? 'Memuat merek...' : 'Pilih jenis kendaraan dulu'} disabled style={{ borderRadius: 8 }} />
								}
							</Form.Item>

							{/* Golongan — pada mode tambah, aktif & wajib setelah Merek dipilih */}
							<Form.Item
								label={
									<span>
										<TagsOutlined style={{ color: '#1e4d8a', marginRight: 6 }} />
										Golongan
										{!isEdit && kodeMerek == null && (
											<Text type="secondary" style={{ fontSize: 11, marginLeft: 8 }}>
												(pilih merek dulu)
											</Text>
										)}
									</span>
								}
								name="golongan"
								rules={!isEdit ? [{ required: true, message: 'Golongan harus dipilih' }] : []}
							>
								{loadingGolongan
									? <Select placeholder="Memuat..." disabled style={{ borderRadius: 8 }} />
									: <Select
										showSearch
										allowClear
										disabled={!isEdit && kodeMerek == null}
										placeholder={!isEdit && kodeMerek == null ? 'Pilih merek terlebih dahulu' : 'Pilih golongan'}
										optionFilterProp="children"
										style={{ borderRadius: 8 }}
									>
										{(listGolongan
											? (listGolongan.results || (Array.isArray(listGolongan) ? listGolongan : []))
											: []
										).map(item => (
											<Select.Option key={item.id} value={item.id}>
												{item.kode} - {item.nama}
											</Select.Option>
										))}
									</Select>
								}
							</Form.Item>

							{/* Nama */}
							<Form.Item
								label={<span><AppstoreOutlined style={{ color: '#1e4d8a', marginRight: 6 }} />Nama Tipe</span>}
								name="nama"
								validateTrigger={['onChange']}
								rules={[
									{ required: true, message: 'Nama tipe harus diisi' },
									{ validator: this.validateNamaTidakDuplikat },
								]}
							>
								<Input placeholder="Contoh: Avanza, Innova, Vario..." style={FIELD_STYLE} onChange={this.handleNamaChange} />
							</Form.Item>

							{/* Generate Kode */}
							<Form.Item
								label={<span><TagOutlined style={{ color: '#1e4d8a', marginRight: 6 }} />Kode</span>}
								style={{ marginBottom: 0 }}
							>
								<Row gutter={8} align="middle">
									<Col flex={1}>
										<Form.Item
											name="kode"
											noStyle
											rules={[{ required: true, message: 'Kode harus diisi' }]}
										>
											<Input
												placeholder="Klik Generate untuk mengisi kode"
												style={{ ...FIELD_STYLE, background: '#f5f5f5', color: '#555', cursor: 'not-allowed' }}
												readOnly
											/>
										</Form.Item>
									</Col>
									<Col>
										<Button
											icon={<SyncOutlined spin={loadingGenerate} />}
											disabled={!canGenerate}
											loading={loadingGenerate}
											onClick={() => this.generateKode()}
											style={{
												borderRadius: 8,
												height: 38,
												borderColor: canGenerate ? '#1e4d8a' : undefined,
												color: canGenerate ? '#1e4d8a' : undefined,
											}}
										>
											{!isMobile && 'Generate'}
										</Button>
									</Col>
								</Row>
							</Form.Item>
							{!isEdit && !canGenerate && (
								<Text type="secondary" style={{ fontSize: 11, display: 'block', marginTop: 4 }}>
									{kodeJenis == null || kodeMerek == null
										? 'Pilih Jenis dan Merek terlebih dahulu untuk generate kode otomatis'
										: 'Isi Nama Tipe yang belum terdaftar untuk bisa generate kode otomatis'}
								</Text>
							)}
						</div>

						{/* ── Footer tombol ── */}
						<Divider style={{ margin: 0 }} />
						<div style={{
							padding: '16px 28px',
							display: 'flex', gap: 10,
							justifyContent: isMobile ? 'stretch' : 'flex-end',
							flexDirection: isMobile ? 'column' : 'row',
							background: '#fafafa',
						}}>
							<Link to={configClass.pageUrl.data} style={isMobile ? { display: 'block' } : {}}>
								<Button
									icon={<CloseCircleOutlined />}
									size="large"
									disabled={loadingButton}
									style={{ borderRadius: 10, ...(isMobile ? { width: '100%' } : {}) }}
								>
									Batal
								</Button>
							</Link>
							<Button
								type="primary"
								htmlType="submit"
								icon={<SaveOutlined />}
								size="large"
								loading={loadingButton}
								disabled={errComponent || !canSubmit}
								style={{
									borderRadius: 10,
									background: 'linear-gradient(135deg, #0f2847, #1e4d8a)',
									border: 'none',
									fontWeight: 600,
									...(isMobile ? { width: '100%' } : {}),
								}}
							>
								{isEdit ? 'Simpan Perubahan' : 'Tambah Tipe'}
							</Button>
						</div>
					</Card>
				</Form>
			</div>
		);
	}
}

const mapStateToProps = function (state) { return state.configReducers; }

export default connect(mapStateToProps, { initHandler, setConfig, ajaxViewHandler, ajaxHandler })(FormTipe);
